module.exports = __webpack_public_path__ + "img/Suunto_step_2.ed76395a.png";